const fahrzeugZustand = require('../enums/fahrzeug-zustand')
const getAge = require('./getAge')

// Ab dieser Laufleistung gilt die Angabe als risikoerhöhend
const MAX_LAUFLEISTUNG = 10000
// Unter diesem Alter gilt der jüngste Fahrer als risikoerhöhend
const MIN_FAHRERALTER = 23
// Jede Nutzung außer reiner Liebhabernutzung, siehe enums/nutzungen.js
const RISIKO_NUTZUNGEN = [2, 3, 4, 5]
// Offener Standort, siehe enums/abstellplaetze.js
const RISIKO_ABSTELLPLAETZE = [4]
// Baulich verändert und bauliche Veränderung geplant, wie in helpers/calculateInsurance.js
const RISIKO_ZUSTAENDE = [fahrzeugZustand.tuned.api, fahrzeugZustand.plannedTuning.api]

// Bei Fahrerkreis "Versicherungsnehmer" ist der VN der einzige Fahrer, sein Geburtsdatum steht
// in geburtsdatumFahrerkreisMax bzw. am Kunden. Sonst ist Min der jüngste Fahrer.
// Gleiche Verzweigung wie in helpers/calculateInsurance.js
function getGeburtsdatumJuengsterFahrer (order) {
  if (order.fahrerkreis === 1) {
    if (order.customer && order.customer.misc && order.customer.misc.GEBDAT) return order.customer.misc.GEBDAT
    return order.geburtsdatumFahrerkreisMax
  }
  return order.geburtsdatumFahrerkreisMin || order.geburtsdatumFahrerkreisMax
}

// Prüft, ob im Antrag risikoerhöhende Angaben stehen. Noch nicht gemachte Angaben zählen nicht.
module.exports = function hasRiskFactors (order) {
  if (!order) return false
  const carData = order.carData || {}

  if (RISIKO_ZUSTAENDE.includes(carData.zustand)) return true
  if (carData.laufleistung > MAX_LAUFLEISTUNG) return true
  if (RISIKO_ABSTELLPLAETZE.includes(carData.abstellplatz)) return true
  if (RISIKO_NUTZUNGEN.includes(carData.nutzung)) return true

  const geburtsdatumJuengsterFahrer = getGeburtsdatumJuengsterFahrer(order)
  if (geburtsdatumJuengsterFahrer && getAge(geburtsdatumJuengsterFahrer) < MIN_FAHRERALTER) return true

  return false
}
